import { Trans, useTranslation } from "react-i18next";
import React, { useMemo, useState } from "react";
import {
  Popup,
  PopupActions,
  PopupContent,
} from "../../components/Common/Popup";
import { Field, Form, Formik } from "formik";
import FormikTextField from "../../components/Common/FormikTextField";
import * as Yup from "yup";
import { getYUPValidators } from "../../components/yupvalidators";
import LoadingButton from "../../components/LoadingButton";
import { usePictureSets } from "../hooks/usePictureSets";
import EpmsImage from "../../components/Common/EpmsImage";
import makeStyles from "@mui/styles/makeStyles";
import { callAPI } from "../../lib/common";
import Container from "@mui/material/Container";

const useStyles = makeStyles({
  favoriteContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    "& img": {
      maxWidth: "100%",
      maxHeight: "30vh",
    },
  },
});

const SetSubjectNameDialog = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { update, currentPictureSet } = usePictureSets();
  const [isSaving, setIsSaving] = useState(false);

  const subjectIP = useMemo(() => {
    return currentPictureSet.pictures.reduce((ip, picture) => {
      console.log("Checking picture", picture);
      if (picture.keywords.indexOf("favorite") >= 0) {
        return picture;
      }
      if (!ip && picture.pictureType === "IP") {
        return picture;
      }
      return ip;
    }, null);
  }, [currentPictureSet]);

  return (
    <Popup onClose={props.onClose}>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
        }}
        validateOnMount={true}
        validationSchema={schema(t)}
        onSubmit={(values) => {
          setIsSaving(true);
          callAPI(
            "/api/webshop/user/picture-sets/" + currentPictureSet.subject.uuid,
            "PATCH",
            values,
          ).then(() => {
            update();
          });
        }}
      >
        {({ isValid }) => {
          return (
            <Form>
              <PopupContent>
                <Container maxWidth="xs">
                  <p>
                    {subjectIP ? (
                      <Trans>
                        To keep track of all of your added picture sets we ask
                        you to kindly provide the full name of the person in
                        this picture.
                      </Trans>
                    ) : (
                      <Trans>
                        To keep track of all of your added picture sets we ask
                        you to kindly provide the full name of the person in
                        this picture set.
                      </Trans>
                    )}
                  </p>
                  {subjectIP && (
                    <div className={classes.favoriteContainer}>
                      <EpmsImage uuid={subjectIP.uuid} size={320} lockedSize />
                    </div>
                  )}
                  <Field
                    label={t("First name of the person in this picture")}
                    name="firstName"
                    component={FormikTextField}
                    variant="outlined"
                  />
                  <Field
                    label={t("Last name of the person in this picture")}
                    name="lastName"
                    component={FormikTextField}
                    variant="outlined"
                  />
                </Container>
              </PopupContent>

              <PopupActions>
                <LoadingButton
                  isLoading={isSaving}
                  fullWidth
                  disabled={!isValid}
                >
                  {t("Save")}
                </LoadingButton>
              </PopupActions>
            </Form>
          );
        }}
      </Formik>
    </Popup>
  );
};

const schema = (t) => () => {
  const validators = getYUPValidators(t);
  return Yup.object().shape({
    firstName: validators.NAME_PART.required(t("This is required!")),
    lastName: validators.NAME_PART.required(t("This is required!")),
  });
};

export default SetSubjectNameDialog;
